import styled from "styled-components";

export const FlexExpandingWrapper = styled.div`
  flex-grow: 1;
`;
